import { cva } from "class-variance-authority"

export const sharedVariantStyles = {
	default:
		"bg-gray-900 text-gray-50 hover:text-white dark:hover:text-gray-900 ring-gray-900 dark:ring-gray-100 hover:bg-gray-700 dark:bg-gray-100 dark:text-gray-900 dark:hover:bg-gray-200 dark:shadow-[inset_0_0_0_1px_rgba(255,255,255,1),0_1px_2px_0_rgba(0,0,0,1)]",
	outline:
		"shadow-sm ring-1 dark:shadow-black ring-black/15 dark:hover:bg-gray-750 bg-white hover:bg-gray-100 dark:ring-white/15 dark:bg-gray-800 dark:text-gray-200",
	// For controls sitting on a blue surface, such as the AI agent's message bubble.
	"outline-blue":
		"shadow-sm ring-1 ring-blue-600/25 bg-white/60 text-blue-800 hover:bg-white dark:shadow-black dark:ring-white/25 dark:bg-white/10 dark:text-white dark:hover:bg-white/20",
	"outline-subtle":
		"ring-1 ring-gray-200 bg-white text-secondary dark:shadow-sm dark:shadow-black hover:bg-gray-50 hover:text-primary dark:ring-gray-700/80 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-750",
	// Emoji reaction chips, after Linear's: translucent so they sit on the gray and the blue bubble alike.
	reaction:
		"bg-black/[0.04] text-secondary hover:bg-black/[0.08] hover:text-primary dark:bg-white/5 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-gray-200",
	// A reaction you added. Hover thins the tint, hinting that a click takes it back.
	"reaction-selected":
		"ring-1 ring-blue-500/30 bg-blue-500/10 text-blue-700 hover:bg-blue-500/5 dark:ring-blue-400/30 dark:bg-blue-500/20 dark:text-white dark:hover:bg-blue-500/10",
	ghost:
		"bg-transparent ring-transparent text-secondary hover:text-primary hover:bg-gray-100 dark:hover:bg-gray-800 dark:data-[state=open]:bg-transparent",
	link: "bg-transparent ring-transparent !px-0 text-secondary hover:text-primary",
	"link-no-hover":
		"bg-transparent ring-transparent !px-0 text-secondary hover:text-secondary",
	"link-muted": "bg-transparent !px-0 text-tertiary hover:text-secondary",
	danger:
		"bg-red-500 text-white dark:shadow-sm dark:shadow-black ring-1 ring-red-500 dark:ring-red-500 hover:bg-red-600 dark:bg-red-500 dark:text-white dark:hover:bg-red-400",
	"green-subtle":
		"bg-green-50 text-green-700 ring-green-200 hover:bg-green-100 dark:bg-green-500/10 dark:text-green-300 dark:ring-green-500/25 dark:hover:bg-green-500/[0.15]",
	"danger-ghost":
		"bg-transparent ring-transparent text-red-500 hover:bg-red-500/10 dark:text-red-400 dark:hover:bg-red-500/10",
	"warning-ghost":
		"bg-transparent ring-transparent text-yellow-500 hover:bg-gray-200 dark:text-yellow-400 dark:hover:bg-gray-800",
	portal:
		"bg-[var(--portal-accent-color)] dark:shadow-sm dark:shadow-black text-[var(--portal-button-text-color)] hover:bg-[var(--portal-accent-color)] hover:opacity-90 ring-[var(--portal-accent-color)]",
	editor: "hover:bg-gray-100 hover:dark:bg-gray-800",
	subtle:
		"bg-gray-100 text-gray-900 dark:shadow-sm dark:shadow-black hover:bg-gray-200 dark:hover:bg-gray-800 dark:bg-gray-700 dark:text-gray-100",
	dashed:
		"shadow-sm ring-1 ring-black/15 dark:shadow-black dark:hover:bg-gray-800 bg-transparent hover:bg-gray-100 dark:ring-white/10 dark:text-gray-200",
	// Something the system suggests, one click to apply: Linear's dashed quick-suggestion chip.
	suggested:
		"border border-dashed border-gray-300 bg-transparent text-primary hover:bg-gray-100 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-800",
	glass:
		"shadow-sm ring-1 dark:shadow-black ring-black/15 dark:hover:bg-gray-800 bg-white hover:bg-gray-50 dark:ring-white/10 dark:bg-gray-850 dark:text-gray-200",
	cta: "bg-gray-900 text-white shadow-sm ring-1 ring-gray-900 transition-colors hover:bg-gray-800 hover:text-white dark:bg-gray-850 dark:text-gray-200 dark:shadow-black dark:ring-white/10 dark:hover:bg-gray-800 dark:hover:text-gray-200",
	glassPrimary:
		"[background-color:color-mix(in_srgb,rgb(17_24_39)_85%,transparent)] hover:[background-color:color-mix(in_srgb,rgb(31_41_55)_85%,transparent)] dark:[background-color:color-mix(in_srgb,rgb(255_255_255)_25%,transparent)] dark:hover:[background-color:color-mix(in_srgb,rgb(255_255_255)_35%,transparent)] [backdrop-filter:blur(8px)_saturate(140%)] [-webkit-backdrop-filter:blur(8px)_saturate(140%)] [box-shadow:inset_0_0_0_1px_color-mix(in_srgb,rgb(255_255_255)_8%,transparent),inset_1.8px_3px_0px_-2px_color-mix(in_srgb,rgb(255_255_255)_20%,transparent),inset_-2px_-2px_0px_-2px_color-mix(in_srgb,rgb(255_255_255)_18%,transparent),inset_-3px_-8px_1px_-6px_color-mix(in_srgb,rgb(255_255_255)_12%,transparent),inset_-0.3px_-1px_4px_0px_color-mix(in_srgb,rgb(0_0_0)_15%,transparent),inset_-1.5px_2.5px_0px_-2px_color-mix(in_srgb,rgb(0_0_0)_20%,transparent),inset_0px_3px_4px_-2px_color-mix(in_srgb,rgb(0_0_0)_20%,transparent),inset_2px_-6.5px_1px_-4px_color-mix(in_srgb,rgb(0_0_0)_12%,transparent),0px_1px_5px_0px_color-mix(in_srgb,rgb(0_0_0)_12%,transparent),0px_6px_16px_0px_color-mix(in_srgb,rgb(0_0_0)_10%,transparent)] dark:[box-shadow:inset_0_0_0_1px_color-mix(in_srgb,rgb(255_255_255)_15%,transparent),inset_1.8px_3px_0px_-2px_color-mix(in_srgb,rgb(255_255_255)_45%,transparent),inset_-2px_-2px_0px_-2px_color-mix(in_srgb,rgb(255_255_255)_40%,transparent),inset_-3px_-8px_1px_-6px_color-mix(in_srgb,rgb(255_255_255)_30%,transparent),inset_-0.3px_-1px_4px_0px_color-mix(in_srgb,rgb(0_0_0)_8%,transparent),inset_-1.5px_2.5px_0px_-2px_color-mix(in_srgb,rgb(0_0_0)_12%,transparent),inset_0px_3px_4px_-2px_color-mix(in_srgb,rgb(0_0_0)_12%,transparent),inset_2px_-6.5px_1px_-4px_color-mix(in_srgb,rgb(0_0_0)_8%,transparent),0px_1px_5px_0px_color-mix(in_srgb,rgb(0_0_0)_6%,transparent),0px_6px_16px_0px_color-mix(in_srgb,rgb(0_0_0)_5%,transparent)]",
}

export const buttonVariants = cva(
	"relative flex flex-none select-none ring-1 ring-transparent items-center justify-center gap-2 rounded-full font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-600 max-w-xs",
	{
		variants: {
			variant: sharedVariantStyles,
			isRounded: {
				true: "rounded-full",
			},
			size: {
				xs: "h-4 min-h-[1.5rem] px-2.5 text-xxs",
				sm: "h-6 min-h-[1.75rem] px-2.5 text-xs",
				default: "h-7 min-h-7 px-3 text-xs",
				lg: "h-9 px-4 text-[13px]",
				xl: "px-[28px] py-3 text-sm rounded-full",
				"2xl": "px-[28px] py-3 text-lg",
			},
		},
		defaultVariants: {
			variant: "default",
			size: "default",
		},
	},
)

export type buttonVariantsType =
	| "default"
	| "link"
	| "portal"
	| "outline"
	| "outline-subtle"
	| "reaction"
	| "reaction-selected"
	| "green-subtle"
	| "ghost"
	| "danger"
	| "editor"
	| "link-muted"
	| "dashed"
	| "suggested"
	| "glass"
	| "glassPrimary"
	| "cta"
